import { FormattedMessage } from 'react-intl';
import { Icon, IconColor } from '@ets/design-system';

import styles from './Priority.module.scss';

import { IconName } from '@ets/design-system';

type Priority = PDF.Annotation['priority'];

type PriorityProps = {
  type: 'comment' | 'annotation';
  oldPriorityId: Priority | null;
  newPriorityId: Priority;
};

const PRIORITY: {
  [key in Priority]: { icon: IconName; color: IconColor; labelId: string };
} = {
  High: {
    icon: 'chevron-up',
    color: 'error',
    labelId: 'editor.sidebar.review.filter.priority.high',
  },
  Medium: {
    icon: 'equals',
    color: 'warning',
    labelId: 'editor.sidebar.review.filter.priority.medium',
  },
  Low: {
    icon: 'chevron-down',
    color: 'success',
    labelId: 'editor.sidebar.review.filter.priority.low',
  },
};

const Priority = ({ type, oldPriorityId, newPriorityId }: PriorityProps) => {
  const getPriority = (priorityId: Priority) => {
    const priority = PRIORITY[priorityId];
    const icon: IconName | null = priority.icon;

    return (
      <div
        className={styles.priority}
        data-testid={`notification-priority-${
          priorityId === oldPriorityId ? 'old' : 'new'
        }-${priorityId.toLowerCase()}`}
      >
        <Icon
          testId={`notification-priority-${
            priorityId === oldPriorityId ? 'old' : 'new'
          }-${priorityId.toLowerCase()}`}
          icon={icon}
          color={priority.color}
          size="3"
          style={{ margin: '0 0.5rem 0 0' }}
        />
        <FormattedMessage id={priority.labelId} />
      </div>
    );
  };

  if (oldPriorityId == null || newPriorityId == null || type == null) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        {oldPriorityId && (
          <>
            {getPriority(oldPriorityId)}
            <div className={styles.arrow}>→</div>
          </>
        )}
        {getPriority(newPriorityId)}
      </div>
    </div>
  );
};

export default Priority;
